<template>
  <b-modal :active.sync="opened" width="300px" scroll="keep">
    <div class="card">
      <div class="card-content tw-p-6">
        <div class="section-block">
          <span class="title">Confirm Delete Event</span>
        </div>

        <div class="columns">
          <div class="column delete-event">
            <skeleton-loading v-if="isLoading" />
            <div v-else>
              <p>Are you sure you want to delete this event?</p>

              <p class="tw-mt-3">
                Title:
                <strong class="has-text-primary">{{
                  eventDetails.title
                }}</strong>
              </p>

              <p v-if="errors" class="tw-mt-5 has-text-danger">
                <small><em>Something went wrong, try again</em></small>
                <br /><small
                  ><em>{{ errors }}</em></small
                >
              </p>

              <div class="level tw-mt-10">
                <div class="level-left">
                  <a class="has-text-grey" @click.prevent="goToForm()"
                    >Cancel</a
                  >
                </div>
                <div class="level-right">
                  <b-button
                    type="is-primary"
                    :disabled="isLoading || isSubmitting"
                    @click.prevent="deleteEvent()"
                    >{{
                      isSubmitting ? btnText.deleting : btnText.default
                    }}</b-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    event: { type: Object }
  },
  data() {
    return {
      opened: false,
      isLoading: false,
      isSubmitting: false,
      prevAction: '',
      errors: '',
      eventDetails: [],
      btnText: {
        default: 'Yes, delete the event',
        deleting: 'Deleting...'
      }
    }
  },
  computed: {
    ...mapState({
      calendarAction: state => state.calendar.action
    })
  },
  methods: {
    ...mapActions({
      deleteCalendarEvent: 'group/deleteCalendarEvent',
      getCalendarSingleEvent: 'group/getCalendarSingleEvent'
    }),
    ...mapMutations(['setCalendarAction']),

    open() {
      this.opened = true
      this.getGroupEvent()
      this.prevAction = this.calendarAction
    },
    goToForm() {
      this.opened = false
      this.$emit('closed')
      this.setCalendarAction(this.prevAction)
    },
    async getGroupEvent() {
      this.isLoading = true

      await this.getCalendarSingleEvent(this.event.id)
        .then(data => {
          this.eventDetails = data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    deleteEvent() {
      this.isSubmitting = true

      this.deleteCalendarEvent(this.event.id)
        .then(() => {
          this.opened = false
          this.setCalendarAction('')
          this.$emit('closed')
        })
        .catch(error => {
          this.errors = error
        })
        .finally(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
.delete-event
  p
    line-height: 1.3em

.section-block
  margin: 0 0 15px

  .title
      padding: 0 0 5px
</style>
